<template>
  <div class="out_wrap">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="tab in tabList" :key="tab.value" :label="tab.name" :name="tab.value" />
    </el-tabs>

    <div v-if="noticeShow" class="active_color mr15 mb10 pointer" @click="noticeShow = !noticeShow">查看指南</div>
    <div v-if="!noticeShow" class="useGuide mb22">
      <div>
        <span class="fs16 bold">使用指南</span>
        <a class="closeGuide active_color ml20" @click="noticeShow = !noticeShow">关闭指南</a>
      </div>
      <div style="line-height: 22px;margin-top: 16px;" class="c9">
        <div>1.发起对账单或者签署对账单时，需要联系超级管理员后台申请财务印章并授权可使用人。</div>
        <div>2.如若贵司未在企业资料中上传“一般纳税人文件”，首次发起或者签署对账单需要上传“一般纳税人文件”。</div>
        <div>3.每月最后一天往前推五个工作日，期间无法主动发起对账，如有特殊需求请联系平台方。</div>
        <div>4.每日12点后可生成昨日数据，12点前只可发起前天之前的对账数据。</div>
        <div>5.平台方发起对账后，请及时确认并签署对账单。如未及时处理，3个工作日后自动确认。</div>
      </div>
    </div>
    <!-- <keep-alive>
      <component
        :is="activeName"
        ref="tab"
      />
    </keep-alive> -->
    <component
      :is="activeName"
      ref="tab"
    />
  </div>
</template>

<script>
import NoAccountCheck from './components/noAccountCheck.vue'
import AccountCheckUnderway from './components/accountCheckUnderway.vue'
import HaveCheck from './components/haveCheck.vue'
import AccountInvalid from './components/accountInvalid.vue'
export default {
  components: {
    NoAccountCheck,
    AccountCheckUnderway,
    HaveCheck,
    AccountInvalid
  },
  data() {
    return {
      activeName: this.$route.query.tab || 'NoAccountCheck',
      noticeShow: false,
      tabList: [{
        name: '未对账',
        value: 'NoAccountCheck'
      }, {
        name: '对账中',
        value: 'AccountCheckUnderway'
      }, {
        name: '已对账',
        value: 'HaveCheck'
      }, {
        name: '作废对账',
        value: 'AccountInvalid'
      }]
    }
  },
  methods: {
    handleClick() {}
  }
}
</script>

<style lang="less" scoped>

</style>
